import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

const LoaderOverlay = styled.div`
  position: fixed;
  top: 70px; /* adjust to the height of your header */
  left: 240px; /* adjust to the width of your left navigation bar */
  width: calc(100vw - 250px); /* adjust to the width of your left navigation bar */
  height: calc(100vh - 60px); /* adjust to the height of your header and footer */
  background-color: rgba(0, 0, 0, 0.4); /* adjust the opacity to your liking */
  z-index: 1000; /* ensure it's on top of other elements */
  backdrop-filter: blur(8px); /* apply blur effect to the background */
  -webkit-backdrop-filter: blur(8px);
  z-index: 9999;
`;

const LoaderAnimation = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  border: 5px solid #f1f1f1;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const Loader = ({ isMobile }) => {
  if (isMobile) {
    return (
      <LoaderOverlay style={{ width: '100%', left: '0px' }}>
        <LoaderAnimation />
      </LoaderOverlay>
    );
  } else {
    return (
      <LoaderOverlay>
        <LoaderAnimation />
      </LoaderOverlay>
    );
  }
};

export default Loader;
